import { msg } from "@lingui/core/macro";

// Строка внизу описания предмета на странице героя: доля всех сильных на герое и минута.
export const HERO_ITEM_FOOTER = msg({
  id: "builds.overview.item_footer",
  message: "Taken by {share} on {hero} · on average {time}",
});
